//Comentario necesario para codificación en UTF-8, ver Inc6743
(function () {
	angular.module('pphhApp')
	.controller("OpenAdmResponsableDialogController", ["$scope", "$mdDialog", "$http", "roleName", 
		OpenAdmResponsableDialogController]);

	function OpenAdmResponsableDialogController($scope, $mdDialog, $http, roleName) {
	
		$scope.sourceResults = {};
	
		$scope.filtroAdmResponsable = {};
	
		$scope.selectOnSource = function(row) {
			$mdDialog.hide({key: row.admCompetente.key, value: row.admCompetente.value});
		};
	
		$scope.lookup = function() {
			var tableState = $scope.stCtrl.tableState();
			tableState.pagination.start = 0;
			$scope.stCtrl.pipe();
		}
	
		$scope.doLookup = function (tableState, ctrl) {
	
			if(!$scope.stCtrl && ctrl) {
		        $scope.stCtrl = ctrl;
		    }
	
		    if(!tableState && $scope.stCtrl) {
		        $scope.stCtrl.pipe();
		        return;
		    }
	
		    if(!$scope.lookupForm.$valid) {
		    	return;
		    }
	
		    var filter = SmartTableUtils.copyAndSetGenericPaginationParams(tableState, $scope.filtroAdmResponsable);
			filter.roleName = roleName;
	
		    $http({
				method: "GET",
				url: "/cc/adm-dialog",
				params: filter
			})
			.then(
				function (response) {
					var queryResults = response.data;
					if(response.data.results) {
						$scope.sourceResults = queryResults.results;
						$scope.sourcePageSize = queryResults.pageSize;
						SmartTableUtils.updateTableState(tableState, queryResults);
					}
				},
				function () {
					$mdDialog.show(
							$mdDialog.alert({
								title: UIMessages.dialog.confirm.title,
								textContent: "Error lookup",
								ok: UIMessages.dialog.confirm.cerrar
							}));
				}
			);
		};
	}
})();